// export const API_URL = 'http://127.0.0.1:5000/v1';
// export const API_URL = 'http://192.168.31.226:80/v1';
export const API_URL = 'https://api.piepower.in/v1';


export const createTestReport = async (data) => {
  const response = await fetch(`${API_URL}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return response.json();
};


export const getBaseUrl = () => {
 
  return API_URL.replace(/\/v1$/, '');
};


export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const cleanPath = imagePath.replace(/^\/+/, '');
  

  const baseUrl = getBaseUrl();
  return `${baseUrl}/${cleanPath}`;
};